import styled from "styled-components";

export const StyledTabGroup = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 2px;
`;
